function Footer() {
  return (
    <div className="w-full overflow-x-hidden h-fit ">
      <div className="flex w-full bg-[rgba(28,41,48,1.00)] p-4">
        <div className="Typewriterr">
          <p className="text-5xl font-bold tracking-wider">TRAVFRUIT</p>
        </div>
      </div>
    </div>
  );
}
export default Footer;
